const dataSourcePath = 'series[0].dataSource';

export const activeHierarchyIdPath = `${dataSourcePath}.activeHierarchyId`;
export const configOrderPath = 'configuration.order';
export const datasetUidPath = `${dataSourcePath}.datasetUid`;
export const dataSourceTypePath = `${dataSourcePath}.type`;
export const dimensionColumnPath = `${dataSourcePath}.dimension.columns`;
export const filtersPath = `${dataSourcePath}.filters`;
export const searchStringPath = `${dataSourcePath}.searchString`;

export const configurationOrderPath = (index: number) => `${dataSourcePath}.hierarchies[${index}].order`;
export const columnConfigurationPath = (index: number) =>
  `${dataSourcePath}.hierarchies[${index}].columnConfigurations`;
export const columnSortConfigurationPath = (index: number) =>
  `${dataSourcePath}.hierarchies[${index}].columnSortConfig`;
export const headerSortCycleIndexPath = (index: number) =>
  `${dataSourcePath}.hierarchies[${index}].headerSortCycleIndex`;
export const pivotColumnOrderPath = (index: number) =>
  `${dataSourcePath}.hierarchies[${index}].pivotColumnOrder`;
export const pivotColumnWidthsPath = (index: number) =>
  `${dataSourcePath}.hierarchies[${index}].pivotColumnWidths`;
export const pivotModePath = (index: number) => `${dataSourcePath}.hierarchies[${index}].pivotMode`;
export const rowGroupCountPath = (index: number) => `${dataSourcePath}.hierarchies[${index}].rowGroupCount`;
export const hasAggregationPath = (index: number) => `${dataSourcePath}.hierarchies[${index}].hasAggregation`;
export const showGrandTotalPath = (index: number) => `${dataSourcePath}.hierarchies[${index}].showGrandTotal`;
export const showSubTotalPath = (index: number) => `${dataSourcePath}.hierarchies[${index}].showSubTotal`;
export const customLabelsPath = (index: number) => `${dataSourcePath}.hierarchies[${index}].customLabels`;
